// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"aQ-z","inlineTitle":"bQ-z","sponsoredAdsWrapper":"cQ-z","marketplaceRecosWrapper":"dQ-z"};